import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=04e0c9a5"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports